import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Blocks an already-authenticated principal from reaching /auth (e.g. via the
 * browser Back button on a shared device) — without this, a second person could
 * log in over a first person's still-active tab instead of being routed to /panel.
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return router.createUrlTree(['/panel/dashboard']);
  }

  return true;
};
